import FrontPageAttraction from "../visualbloc/frontPageAttraction";
function Frontpage(){
    return(
        <div>
            <FrontPageAttraction />
        </div>
    )
}
export default Frontpage;